export default {
      id: "close-card-usage",
      viewBox: "0 0 20 15",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#close-card",
      toString: function () {
        return this.url;
      }
    }